module.exports = __webpack_public_path__ + "static/media/squared.07054690.jpg";